import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './axios.config'

import vuetify from './plugins/vuetify'
import VueSilentbox from 'vue-silentbox'

// import DisableAutocomplete from '@aacassandra/vue-disable-autocomplete';
// Vue.use(DisableAutocomplete);

Vue.config.productionTip = false
Vue.use(VueSilentbox);

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
